import { render, staticRenderFns } from "./bindGoods.vue?vue&type=template&id=68016766&scoped=true&"
import script from "./bindGoods.vue?vue&type=script&lang=js&"
export * from "./bindGoods.vue?vue&type=script&lang=js&"
import style0 from "./bindGoods.vue?vue&type=style&index=0&id=68016766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68016766",
  null
  
)

export default component.exports